import numeral from 'numeral';
import { numberConstants } from './constants';

export default {
    format: (value, currencySymbol, format = numberConstants.FORMAT) => {
        return numeral(value).format(currencySymbol + format);
    },
    getSymbol: (currency) => {
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                currencyDisplay: 'narrowSymbol',
            })
                .formatToParts(1)
                .map((val) => val.value)[0];
        } catch {
            return currency;
        }
    },
};
